module.exports = __webpack_public_path__ + "img/jackpot-bg_460.71e86ab5.png";